import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { CreateResponseBase } from '@models/base/createResponseBase.model';
import { CotizacionMonedaDto } from '@models/cotizacionModena/cotizacionMonedaDto.model';
import { CreateCotizacionMonedaRequest } from '@models/cotizacionModena/createCotizacionMoneda.model';
import { UpdateCotizacionMonedaRequest } from '@models/cotizacionModena/updateCotizacionMoneda.model';
import { CreateCuentaCajaRequest } from '@models/cuentaCaja/createCuentaCajaRequest.model';
import { UpdateCuentaContableRequest } from '@models/cuentaContable/createCuentaContableRequest.model copy';
import { CuentaContableDto } from '@models/cuentaContable/cuentaContableDto.model';
import { Observable, of } from 'rxjs';
import { isFalsy } from 'utility-types';

@Injectable({
  providedIn: 'root'
})
export class CuentaContableService {
  constructor(private http:HttpClient) {
  }

  create(createCuentaCajaRequest:CreateCuentaCajaRequest):Observable<CreateResponseBase>
  {
    return  this.http.post<CreateResponseBase>("/api/CuentaContable/Create",createCuentaCajaRequest);
  }

  update(updateCuentaContableRequest:UpdateCuentaContableRequest):Observable<any>
  {
    return  this.http.put<any>("/api/CuentaContable/Update",updateCuentaContableRequest);
  }

  getAll():Observable<CuentaContableDto[]> {
    return   this.http.get<CuentaContableDto[]>("/api/CuentaContable/GetAll");
  }

  getById(id:number):Observable<CuentaContableDto>{
    return  this.http.get<CuentaContableDto>("/api/CuentaContable/GetById?id="+id);
  }

  delete(id: number): Observable<any> {
    if (!isFalsy(id))
      return this.http.delete<any>("/api/CuentaContable/Delete?id=" + id);
    else
      return of(null)
  }
}
